shadow$provide[396] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform float textureItems;
uniform float textureHeight;

vec2 mapXyzwTexture(vec4 xyzw) {
  
  float x = xyzw.x;
  float y = xyzw.y;
  float z = xyzw.z;
  float i = xyzw.w;
  
  return vec2(i, y) + vec2(x, z) * vec2(textureItems, textureHeight);
}

`;

};